import React from 'react'

const CustomRadioButton = ({widthHeight, checked}) => {
    const size = widthHeight || 4
    
    return (
        <div className={`w-${size} h-${size} rounded-full flex items-center justify-center border cursor-pointer ${checked ? "bg-[#edfaf6] border-ep-primary-600" : "border-gray-400"}`}>
            <div className={`w-2/4 h-2/4 rounded-full transition-all duration-300 bg-ep-primary-600 ${checked ? "opacity-100" : "opacity-0"}`} />
        </div>
    )
}

export default CustomRadioButton